"use strict";

define('rs/form/section.edit.view',['require','exports','module','rs/form/section.view','rs/helper','rs/form/editelement'],function (require, exports, module) {
  var SectionView = require('rs/form/section.view');
  var helper = require('rs/helper');
  var EditElement = require('rs/form/editelement');
  var SectionEditView = SectionView.extend({
    templates: {
      'content.footer': 'renderFooterFragment',
      'form.section.edit.container': 'renderSectionEditContainerFragment'
    },
    render: function render() {
      this.$el.html(this.renderSectionEditContainerFragment(this.getDelegate()));
      var label = this.$el.find('[data-property="label"]'),
        text = this.$el.find('[data-property="text"]'),
        delegate = this.getDelegate();
      this.$el.addClass('form-section');
      this.setupEditableInput();
      this.listenTo(delegate, 'change:label', function () {
        label.text(delegate.getLabel());
      });
      this.listenTo(delegate, 'change:text', function () {
        text.text(delegate.getText());
      });
    },
    destroy: function destroy() {
      if (this._editableInput) {
        this._editableInput.destroy();
      }
      return this._super.apply(this, arguments);
    },
    createChildElementBeforeEmpty: function createChildElementBeforeEmpty() {
      var container = $('<div />');
      this.$('.empty').before(container);
      return container;
    },
    setupEditableInput: function setupEditableInput() {
      var editableInput = EditElement.delegate(this.$el, '.editable-input').edit(function (el, field, value) {
        var foEl = el.closest('.form-object,.form-section');
        view = null;
        try {
          view = helper.datum(foEl);
        } catch (e) {}
        if (view && value != undefined && field) {
          view.getDelegate()['set' + helper.camelCase(field)](value);
          view.getDelegate().getFormController().formObjectDidChange();
        }
      }).maxLength(function (el) {
        if (el.attr('data-maxlength')) {
          return el.attr('data-maxlength');
        }
        return 0;
      }).width(function (el) {
        if (el.hasClass('section-header-content')) {
          return el.parent().width() - el.position().left;
        }
        return el.parent().width();
      }).rich(function (el) {
        return el.attr('data-type') == 'rich';
      });
      this._editableInput = editableInput;
    },
    setElement: function setElement(el) {
      helper.datum(el, this);
      return this._super.apply(this, arguments);
    }
  });
  module.exports = SectionEditView;
});

